import { IThunkActionCreator } from '../../types/redux';
import { mapGKData } from '../../store/pik_data/gks';
import { mapBannersData, mapBannersForRegion } from '../../store/pik_data/banners';
import { mapOfficeData } from '../../store/pik_data/offices';
import { mapLocationData } from '../../store/pik_data/location';
import { setBanners } from '../banners';
import { initOffices } from '../offices';
import { initLocations } from '../locations';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { setBanks } from '../banks';
import { dateVariationsChange } from '../filter';
import { getGetPikJk } from '../../services/getGetPikJk/getGetPikJk';
import { IPikData } from '../../../typings/api';
import { changeHash } from '../location';

export enum EPikDataActionTypes {
  SetPikData = 'PIKDATA/SET',
}

export type TSetPikData = ITypedReduxAction<EPikDataActionTypes.SetPikData, IPikData>;

export const setPikData: (pikData: IPikData) => TSetPikData = actionGenerator<EPikDataActionTypes.SetPikData, IPikData>(
  EPikDataActionTypes.SetPikData,
);

export function initPikData(): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, { httpApi }) => {
    try {
      const { filter } = getState();
      const pikData: unknown = await getGetPikJk({ httpApi });
      const gks = mapGKData(pikData as IPikData);
      const banners = mapBannersData(pikData as IPikData);
      const offices = mapOfficeData(pikData as IPikData);
      const locations = mapLocationData(pikData as IPikData, gks);
      const bannersForRegion = mapBannersForRegion([filter, banners]);

      dispatch(setPikData(pikData as IPikData));
      dispatch(setBanners(bannersForRegion));
      dispatch(initOffices(offices));
      dispatch(initLocations(locations));
      dispatch(setBanks(filter.query));
      dispatch(dateVariationsChange(filter.query.region));

      /* istanbul ignore else */
      if (window !== undefined) {
        const hash = window.location.hash ? window.location.hash.substr(1) : '';
        dispatch(changeHash(hash));
      }
    } catch (e) {
      console.error(e);
    }
  };
}
